import { Injectable } from '@angular/core';
import { ApiHttp } from '../providers';
import { MessageService } from 'primeng/api';
import { DriverCommerceDto, PaymentTransactionsDto } from '../components/home/drivers/driver-detail/driver-commerce/driver-commerce-dto';
import { ExportFinanceCommerceDto, FinanceCommerceDto } from 'app/components/finance/finance-commerce/finance-commerce';

@Injectable({
  providedIn: 'root'
})
export class CommerceService {
  private productStatus: any;
  private productDetails: any;
  private productDetailValue: any;
  private paymentTermsValue: any;

  constructor(private apiHttp: ApiHttp) { }

  public getDriverCommerce(data: DriverCommerceDto, messageService: MessageService): Promise<any> {
    return this.apiHttp.post(`api/AdminXpressDriverCommerce/GetDriverCommerceFiltered`, data, messageService);
  }

  public getCommerceOverview(dto: any, messageService: MessageService): Promise<any> {
    return this.apiHttp.post(`api/AdminXpressDriverCommerce/GetCommerceOverview`, dto, messageService);
  }

  public getPaymentTransactions(data: PaymentTransactionsDto, messageService: MessageService): Promise<any> {
    return this.apiHttp.post(`api/AdminXpressDriverCommerce/GetDriverCommercePaymentTransaction`, data, messageService);
  }

  public getProductDetail(dto: any, messageService: MessageService): Promise<any> {
    return this.apiHttp.post(`api/AdminXpressDriverCommerce/GetDriverCommerceDetail`, dto, messageService);
  }

  public pauseCommerce(data: any, messageService: MessageService): Promise<any> {
      return this.apiHttp.post('api/AdminXpressDriverCommerce/PauseCommerce', data, messageService);
  }

  public resumeCommerce(data: any, messageService: MessageService): Promise<any> {
      return this.apiHttp.post('api/AdminXpressDriverCommerce/ResumeCommerce', data, messageService);
  }

  public preResumeComputation(data: any, messageService: MessageService): Promise<any> {
      return this.apiHttp.post('api/AdminXpressDriverCommerce/GetPreResumeComputation', data, messageService);
  }

  set availedProductStatus(value: any){
    this.productStatus = value;
  }

  get availedProductStatus(){
    return this.productStatus;
  }

  set availedProductDetails(value: any){
    this.productDetails = value;
  }

   get availedProductDetails(){
    return this.productDetails;
  }

  resetAvailedProductsEdit(){
    this.productDetails = null;
    this.productStatus = null;
  }

  public getAllDriverCommercePaymentTransaction(data: FinanceCommerceDto, messageService: MessageService): Promise<any> {
    return this.apiHttp.post(`api/AdminXpressDriverCommerce/GetAllDriverCommercePaymentTransaction`, data, messageService);
  }

  public exportAllDriverCommercePaymentTransaction(data: ExportFinanceCommerceDto, messageService: MessageService): Promise<any> {
    return this.apiHttp.postDownloadFile(`api/AdminXpressDriverCommerce/ExportAllDriverCommercePaymentTransaction`, data, messageService);
  }

  public exportPaymentTransactions(data: PaymentTransactionsDto, messageService: MessageService): Promise<any> {
    return this.apiHttp.postDownloadFile(`api/AdminXpressDriverCommerce/ExportDriverCommercePaymentTransaction`, data, messageService);
  }

  public getProductFiltered(dto: any, messageService: MessageService): Promise<any> {
    return this.apiHttp.post(`api/AdminDriverCommerceProduct/GetProductFiltered`, dto, messageService);
  }

  public createCommerce(data: FormData, messageService: MessageService): Promise<any> {
    return this.apiHttp.post(`api/AdminXpressDriverCommerce/CreateCommerce`, data, messageService);
  }

  set productDetailModel(value: any){
    this.productDetailValue = value;
  }

  get productDetailModel(){
    return this.productDetailValue;
  }

  set paymentTermsModel(value: any){
    this.paymentTermsValue = value;
  }

  get paymentTermsModel(){
    return this.paymentTermsValue;
  }

  resetAddProductModels(){
    this.paymentTermsValue = null;
    this.productDetailModel = null;
  }
}
